import React from 'react';
import PropTypes from 'prop-types';
import apiService from '../../services/api';

const deleteImage = apiService.getBlobAssetUrl('Delete_graphic.svg');
const close = apiService.getBlobAssetUrl('close_popup.svg');

const DeleteTeam = ({ settingName, onCancel, onConfirm }) => {
  return (
      <div className="add-survey-modal" id="edit-34">
        <div id="delete-2">
          <div className="modal-header" id="edit-33">
            <h3 id="delete-51">Delete</h3>
            <button className="close-btn" onClick={onCancel}>
              <img src={close} alt="close" className="close-img" id="edit-111" />
            </button>
          </div>
          <br />
          
          <img src={deleteImage} alt="delete" className="delete-img" id="delete-3" />
          <p id="delete-4">Are you sure you want to Delete the team member <span id="delete-6">“{settingName}”?</span></p>
          <br />
          <div className="modal-actions" id="modal-actions11">
            <button onClick={onCancel} id="delete-no">
              No
            </button>
            <button onClick={onConfirm} id="edit-10">
              Yes
            </button>
          </div>
        </div>
      </div>
  );
};

// PropTypes validation
DeleteTeam.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  settingName: PropTypes.func.isRequired,
};

export default DeleteTeam;